import { render, staticRenderFns } from "./TitleSizePage.vue?vue&type=template&id=7b95ea27&scoped=true&"
import script from "./TitleSizePage.vue?vue&type=script&lang=ts&"
export * from "./TitleSizePage.vue?vue&type=script&lang=ts&"
import style0 from "./TitleSizePage.vue?vue&type=style&index=0&id=7b95ea27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b95ea27",
  null
  
)

export default component.exports